module.exports = __webpack_public_path__ + "img/award.0cf9a246.svg";